/**
 * @typedef {import('@/types').EngineContext} EngineContext
 * @typedef {import('@/types').EngineSnapshot} EngineSnapshot
 * @typedef {import('@/types').LiveState} LiveState
 * @typedef {import('@/types').FilterSource} FilterSource
 */

/**
 * Deep-enough clone for one engine generation. Uses JSON for plain filter data.
 *
 * @template T
 * @param {T} source
 * @returns {T}
 */
export function cloneSnapshot(source) {
	return JSON.parse(JSON.stringify(source));
}

/**
 * Commit a completed snapshot onto App.vue reactive roots.
 *
 * @param {LiveState} liveState
 * @param {EngineSnapshot} snapshot
 */
export function commitSnapshot(liveState, snapshot) {
	liveState.data.results = snapshot.results;
	liveState.data.categories = snapshot.categories;
	liveState.data.currentNav = snapshot.currentNav;
	liveState.data.currentNavResults = snapshot.currentNavResults;
	liveState.data.resultsLoading = snapshot.resultsLoading;
	liveState.data.navLoading = snapshot.navLoading;

	liveState.options.loading = snapshot.loading;

	/** @type {FilterSource[]} */
	let optionKeys = [
		'base',
		'college',
		'term',
		'startsOn',
		'campus',
		'enrollable',
		'format',
		'days',
		'subject',
		'course',
	];
	for (const key of optionKeys) {
		if (snapshot.options[key] !== undefined) {
			// Index signature makes assignment invariant; keys are known filter sources.
			liveState.options[key] = /** @type {any} */ (snapshot.options[key]);
		}
		if (snapshot.selected[key] !== undefined && snapshot._dirtySelectedKeys?.includes(key)) {
			liveState.selected[key] = /** @type {any} */ (snapshot.selected[key]);
		}
	}
}
